import React from 'react';
import Form from '../Form/Form';
import logo from '../assets/Espressiflogo.svg';

const Home = () => {
    return ( 
         <div className="container">
      <div className="row">
          <div className="col-lg-12">
            <div className="logo-container text-center">
            <img src={logo} className="logo" alt="Espressif" />
            <h2 className="my-3"><b>Espressif Alexa</b></h2>
            </div>
          
            <div id="intro">
              <p>This form allows you to quickly create AWS IoT certificates for your device to securely communicate with the Alexa server as part of&nbsp;
                <a href="https://github.com/espressif/esp-va-sdk" target="_blank" rel="noopener noreferrer" className="link">
                  <b>ESP Alexa</b>
                </a>.
              </p>
              <p>After you fill out this form, an email will be sent to you with the required certificates.</p>                            
              <hr className="my-3" />
            </div>

            <Form/>
            
          </div>
        </div>
      </div>
     );
}
 
export default Home;